<section class="content">
    <div class="container mt-5">
        <div class="row">
            <div class="col-md-10">
                <h3>Dexio Messages</h3>
            </div>
        </div>
        <div class="mt-5">
            <textarea class="form-control" row="3" type="text" [value]="messages[0].message" (keyup)="updateMessage($event)"></textarea>
        </div>
        <div class="mt-3 mb-3 row">
            <div class="col"><button class="btn btn-secondary" [class.disabled]="saving" [disabled]="saving" (click)="cancel()">Cancel</button></div>
            <div class="col text-end"><button class="btn btn-primary" [class.disabled]="saving" [disabled]="saving" (click)="save()">Save</button></div>
        </div>
        <div class="mt-5">
            <div>How the message will appear:</div>
            <ng-container *ngIf="messages && messages.length > 0">
                <mat-card class="mt-3 me-3">
                    <mat-card-content>
                    <div class="row text-muted" *ngFor="let message of messages">
                        <div [innerHTML]="message.message"></div>
                    </div>
                    </mat-card-content>
                </mat-card>
            </ng-container>
        </div>
    </div>
</section>
